<div>
  <app-header *ngIf="showHeader"></app-header>
  <alert></alert>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
